import { UserCreate } from '../components/UserCreate'
import { UserList } from '../components/UserList'
import {
  FACMListPending, FACMListAll, FACMListOngoing, FACMListPlanned,
} from '../components/FACMList'
import { FacmDetail } from '../components/FacmDetail'
import { NotificationList } from '../components/NotificationList'
import { Contact } from '../components/Contact'
import { Profile } from '../components/Profile'
import { UserEdit } from '../components/UserEdit'
import { GridList } from '../components/GridList'
import { GridCreate } from '../components/DocumentCreate'
import { InternshipList } from '../components/InternshipList'
import { GridEdit } from '../components/DocumentEdit'
import { EvaluationList } from '../components/EvaluationList'
import { EvaluationShow } from '../components/EvaluationShow'
import { Login } from '../components/Login'
import { ConfirmPassword, ResetPassword } from '../components/ConfirmPassword'
import { ChangeEmail } from '../components/ChangeEmail'
import { ForgotPassword } from '../components/ForgotPassword'
import { NotificationSettingShow } from '../components/NotificationSettingShow'
import { InternshipCreate } from '../components/InternshipCreate'
import { InternshipEdit } from '../components/InternshipEdit'

import {
  ROLES, ROLES_ARRAY, ROLES_BO_FACM, ROLES_BO_EVAL, ROLES_USER_CREATORS,
} from './roles'
import { PATHS } from './paths'

export const routesDescriptions = {
  facmOngoing: {
    component: FACMListOngoing,
    label: 'facmOngoing',
    link: PATHS.FACM_ONGOING,
    roles: ROLES_BO_FACM,
  },
  facmPending: {
    component: FACMListPending,
    label: 'facmPending',
    link: PATHS.FACM_PENDING,
    roles: [ROLES.MOUNTAIN_OFFICER, ROLES.CORPS_CHIEF, ROLES.UNIT_COMMANDER],
  },
  facmPlanned: {
    component: FACMListPlanned,
    label: 'facmPlanned',
    link: PATHS.FACM_PLANNED,
    roles: ROLES_BO_FACM,
  },
  facmAll: {
    component: FACMListAll,
    label: 'facmAll',
    link: PATHS.FACM_ALL,
    roles: ROLES_BO_FACM,
  },
  facmDetail: { link: PATHS.FACM_DETAIL, component: FacmDetail, roles: ROLES_BO_FACM },
  notifications: {
    component: NotificationList,
    label: 'notifications',
    link: PATHS.NOTIFICATION_LIST,
    roles: ROLES_BO_FACM,
  },
  userCreate: {
    component: UserCreate,
    label: 'userCreate',
    link: PATHS.USER_CREATE,
    roles: ROLES_USER_CREATORS,
  },
  userList: {
    component: UserList,
    label: 'userList',
    link: PATHS.USER_LIST,
    roles: ROLES_USER_CREATORS,
  },
  gridList: {
    component: GridList,
    label: 'gridList',
    link: PATHS.GRID_LIST,
    roles: ROLES_BO_EVAL,
    isInternshipDirector: true,
  },
  gridCreate: {
    component: GridCreate,
    link: PATHS.GRID_CREATE,
    roles: ROLES_BO_EVAL,
    isInternshipDirector: true,
  },
  gridEdit: {
    component: GridEdit,
    link: PATHS.GRID_EDIT,
    roles: ROLES_BO_EVAL,
    isInternshipDirector: true,
  },
  internshipList: {
    component: InternshipList,
    label: 'internshipList',
    link: PATHS.INTERNSHIP_LIST,
    roles: ROLES_BO_EVAL,
    canUseInternshipPermission: true,
    isInternshipDirector: true,
  },
  internshipCreate: {
    component: InternshipCreate,
    link: PATHS.INTERNSHIP_CREATE,
    roles: ROLES_BO_EVAL,
    isInternshipDirector: true,
  },
  internshipEdit: {
    component: InternshipEdit,
    link: PATHS.INTERNSHIP_EDIT,
    roles: ROLES_BO_EVAL,
    canUseInternshipPermission: true,
    isInternshipDirector: true,
  },
  contact: {
    component: Contact,
    label: 'contact',
    link: PATHS.CONTACT,
    roles: ROLES_ARRAY,
  },
  profile: {
    component: Profile,
    label: 'profile',
    link: PATHS.PROFILE,
    roles: ROLES_ARRAY,
  },
  userEdit: {
    component: UserEdit,
    label: 'userEdit',
    link: PATHS.USER_EDIT,
    roles: ROLES_USER_CREATORS,
  },
  evaluationList: {
    component: EvaluationList,
    label: 'evaluations',
    link: PATHS.EVALUATION_LIST,
    roles: ROLES_BO_EVAL,
    canUseInternshipPermission: true,
    isInternshipDirector: true,
  },
  evaluationShow: {
    component: EvaluationShow,
    link: PATHS.EVALUATION_SHOW,
    roles: ROLES_BO_EVAL,
    canUseInternshipPermission: true,
    isInternshipDirector: true,
  },
  notificationSettings: {
    component: NotificationSettingShow,
    link: PATHS.NOTIFICATION_SETTINGS,
    roles: [ROLES.ADMIN],
    label: 'notificationSettings',
  },
  login: { link: PATHS.LOGIN, component: Login, isProtected: false },
  confirmPassword: { link: PATHS.CONFIRM_PASSWORD, component: ConfirmPassword, isProtected: false },
  resetPassword: { link: PATHS.RESET_PASSWORD, component: ResetPassword, isProtected: false },
  changeEmail: { link: PATHS.CHANGE_EMAIL, component: ChangeEmail, isProtected: false },
  forgotPassword: { link: PATHS.FORGOT_PASSWORD, component: ForgotPassword, isProtected: false },
}
